import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getProduct } from "../actions/getProduct";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Accordion from "../components/accordion";
import LoadingScreen from "../components/loading-screen";
import TopSection from "../components/product/TopSection";
import SubProductsSection from "../components/product/SubProductsSection";
import Attributes from "../components/product/Attributes";
import BottomSection from "../components/product/BottomSection";
import { Helmet } from "react-helmet-async";

//sub sections

export default function Product() {
    const { productId } = useParams();
    const { i18n, t } = useTranslation();

    const { data, isLoading } = useQuery({
        queryKey: ["global", "product", { productId }],
        queryFn: () =>
            getProduct({
                productId: productId || "",
            }),
    });

    const [subProductID, setSubProductID] = useState(0);
    const [cartAttributes, setCartAttributes] = useState([]);

    const [wantCook, setWantCook] = useState(false);

    if (isLoading) return <LoadingScreen />;
    if (!data) return null;

    // const productNameEn = data?.name || "Halal Product";
    // const productNameAr = data?.category?.name
    //     ? `خروف ${data.category.name} محلي`
    //     : "ذبيحة طازجة";
    const productName = data?.name;
    const shopName = data?.shop?.name;

    const metaTitle =
        i18n.language === "ar"
            ? `${productName} | حلال مزارعنا`
            : `${productName} | Halal Mazarana`;

    const metaDescription =
        i18n.language === "ar"
            ? `اطلب ${productName} من متجر ${shopName}، عبر تطبيق حلال مزارعنا، حمل التطبيق الآن!`
            : `Order ${productName} from ${shopName}, through all in one emirati shop Halal Mazarana, Download now!`;
    return (
        <>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDescription} />
            </Helmet>
            <div className="mx-auto flex max-w-[852px] flex-col px-4 pt-14">
                {/* title,description and image */}
                <TopSection data={data} />
                <div className="flex flex-col gap-y-4">
                    {data.sub_product && data.sub_product?.length > 0 && (
                        <SubProductsSection
                            data={data}
                            setSubProductID={setSubProductID}
                            subProductID={subProductID}
                        />
                    )}

                    <Attributes
                        data={data}
                        cartAttributes={cartAttributes}
                        setCartAttributes={setCartAttributes}
                    />
                </div>
            </div>

            {/* quantity, price and add to cart  */}
            <BottomSection
                data={data}
                cartAttributes={cartAttributes}
                subProductID={subProductID}
            />
        </>
    );
}
